import { useState } from "react";
export interface AccordionStatusType {
  [key: string]: boolean;
  all: boolean;
}
const useAccordion = (initialState: Partial<AccordionStatusType> = {}) => {
  const [accordionStatus, setAccordionStatus] = useState<AccordionStatusType>({
    all: false,
    ...initialState,
  });
  const handleExpandCollapseAllChange = () => {
    const newStatus = !accordionStatus.all;
    const updatedStatus = Object.keys(accordionStatus).reduce((acc, key) => {
      acc[key] = newStatus;
      return acc;
    }, {} as AccordionStatusType);
    setAccordionStatus(updatedStatus);
  };
  const handleIndividualAccordionChange = (accordionName: string) => {
    setAccordionStatus((prevStatus) => ({
      ...prevStatus,
      [accordionName]: !prevStatus[accordionName],
    }));
  };
  const handleSelectedAccordionChange = (value: { [key: string]: boolean }) => {
    setAccordionStatus((prevStatus) => ({
      ...prevStatus,
      ...value,
    }));
  };
  const handleAccordionExpansionState = (
    accordionName: string,
    shouldExpand: boolean,
  ) => {
    setAccordionStatus((prevStatus) => ({
      ...prevStatus,
      [accordionName]: shouldExpand,
    }));
  };
  return {
    accordionStatus,
    handleExpandCollapseAllChange,
    handleIndividualAccordionChange,
    handleSelectedAccordionChange,
    handleAccordionExpansionState,
  };
};
export default useAccordion;
